import {RtRouteMap, RtRouteMapBaseRecursiveObject} from './rt-route-map.types';

/**
 * Create a route map based on the provided object.
 * @param routes - The object to create the route map from.
 */
export const createRoutesMap = <T extends RtRouteMapBaseRecursiveObject>(routes: T): RtRouteMap<T> => {
  // Initialize the stack with the root object (to avoid recursion).
  const stack: Array<{obj: any; path: string; node: any}> = [{obj: routes, path: '', node: {}}];

  // Store the link to the root node.
  const routeMap: any = stack[0].node;

  // Add properties to the root node.
  routeMap.getOwnName = '';
  routeMap.getAbsolutePath = '/';
  routeMap.getAbsolutePathWithParams = () => '';

  // Iterate over the stack to process all levels
  while (stack.length > 0) {
    // Safely pop the stack.
    const current = stack.pop();

    // Destructure only if the current stack is not undefined.
    if (current) {
      const {obj, path, node} = current;

      // Process each key in the current object
      for (const key in obj) {
        // Check if the key is an own property of the object
        if (Object.getOwnPropertyDescriptor(obj, key) !== undefined) {
          // Create the current path.
          const currentPath = `${path}/${key}`;

          // Extend the current node with the additional properties.
          node[key] = {
            getOwnName: key,
            getAbsolutePath: currentPath,
            getAbsolutePathWithParams: (...args: string[]) => {
              let paramIndex = 0;
              // Replace dynamic segments like :id with the corresponding values from args.
              return currentPath.replace(/:([^/]+)/g, () => args[paramIndex++] || '');
            },
          };

          // Push the next level onto the stack if it exists.
          if (Object.keys(obj[key]).length > 0) {
            stack.push({obj: obj[key], path: currentPath, node: node[key]});
          }
        }
      }
    }
  }

  // Return the route map.
  return routeMap as RtRouteMap<T>;
};
